module.exports = __webpack_public_path__ + "img/spirit_320.dac5398c.png";